export function getAttentionText(isMassAction) {
  if (isMassAction) {
    return 'DocumentStapling.MassDeleteAllUsersAttentionTextKey'
  }

  return 'DocumentStapling.ItemDeleteLastUserAttentionTextKey'
}

// A filter narrows the list total, so deleting everything is checked against the unfiltered total
export function isDocFlowDeletingAllTableItems({
  excludeIds,
  isMassAction,
  selectAllPages,
  selectedIds,
  tableItems,
  unfilteredTotal,
}) {
  const listTotal = tableItems?.pagination?.total
  const total = unfilteredTotal ?? listTotal
  const isAllSelected =
    (selectAllPages && excludeIds.length === 0 && listTotal === total) ||
    selectedIds.length === total

  return (isMassAction && isAllSelected) || total === 1
}
